import React, {useEffect, useState} from 'react'
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import Moment from "moment";
import BottomMenu from "../../../layout/bottomMenu";
import {addressApprovalPendingListRequest} from "../../../../service/Lead/action";
const LeadAddressUpdateLogs = ({
                                   addressUpdateLogsResponse,
                                   getAddressUpdateLogsRequest,
                                   match,
                                    history
                        }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [filterInputList, setFilterInputList] = useState([{}])
    const [open, setOpen] = useState(false);
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [pageNo, setPage] = useState(1)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAddressUpdateLogsRequest(match?.params?.lead_id, 1)
            setIsLoading(false)
        })()
    }, [])


    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected+1)
        await getAddressUpdateLogsRequest(match?.params?.lead_id, val?.selected+1,  filterInputList)
        setIsLoading(false)
    };



    const handleSearch = async () => {
        if (searchValue === '') {
            return false
        }
        if(searchValue){
            await getAddressUpdateLogsRequest(match?.params?.lead_id,  1)
        }

    }

    const removeSearchFilter = async () => {
        delete window.localStorage.search_lead
        setIsLoading(true)
        await getAddressUpdateLogsRequest(match?.params?.lead_id, 1)
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await getAddressUpdateLogsRequest(match?.params?.lead_id, pageNo, filterInputList)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if(key !== ''){
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await getAddressUpdateLogsRequest(match?.params?.lead_id, pageNo, filterInputList)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setFilterInputList([{}])
                setIsLoading(true)
                await getAddressUpdateLogsRequest(match?.params?.lead_id, pageNo)
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    {console.log("qwedfds",addressUpdateLogsResponse)}

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Address Logs'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between ">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                                            {/*<form className="form-inline mr-auto w-90 navbar-search">*/}
                                            {/*    <div className="d-flex w-100">*/}
                                            {/*        <input type="text"*/}
                                            {/*               className="form-control bg-light border-0 small list-filter"*/}
                                            {/*               placeholder="Search Lead..." aria-label="Search"*/}
                                            {/*               aria-describedby="basic-addon2"*/}
                                            {/*               onChange={(e) => {*/}
                                            {/*                   setSearchValue(e.target.value)*/}
                                            {/*               }}*/}
                                            {/*        />*/}
                                            {/*        <div className="remove-search-filter">*/}
                                            {/*            <i className="fa fa-times" aria-hidden="true"*/}
                                            {/*               onClick={removeSearchFilter}></i>*/}
                                            {/*        </div>*/}
                                            {/*        <div className="btn-search">*/}
                                            {/*            <button className="btn btn-primary lh-32 border-left-tr-tb"*/}
                                            {/*                    type="button"*/}
                                            {/*                    onClick={(e) => handleSearch()}*/}
                                            {/*            >*/}
                                            {/*                <i className="fas fa-search fa-sm"></i>*/}
                                            {/*            </button>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*</form>*/}
                                        </div>
                                        {/*<div className="col-md-6 cs-pos">*/}
                                        {/*    <button onClick={() => handleApprove()}*/}
                                        {/*            className="btn btn-sm btn-primary mr-1 btn-filter"*/}
                                        {/*            type="button"><i*/}
                                        {/*        className="fa fa-check lh-35 pd-3"></i>*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>


                                <div className="row">
                                    {/*CARD START*/}
                                    {addressUpdateLogsResponse && addressUpdateLogsResponse?.data !== undefined && addressUpdateLogsResponse?.data !== [] && addressUpdateLogsResponse?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    {parseInt(val?.status) === 1 ?
                                                                        <div className="header-ui-item-opp"
                                                                             style={{backgroundColor: "#bea925"}}>
                                                                            Pending
                                                                        </div> : parseInt(val?.status) === 2 ?
                                                                            <div className="header-ui-item-opp">
                                                                                Approved
                                                                            </div> :
                                                                            <div className="header-ui-item-opp"
                                                                                 style={{backgroundColor: "#88130a"}}>
                                                                                Rejected
                                                                            </div>
                                                                    }


                                                                    <div className="row list-view">
                                                                        {val?.old_location &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-search-location"></i>&nbsp;&nbsp;Old
                                                                                    Address
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.old_location}>{val?.old_location}</span>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-cannabis"></i>&nbsp;&nbsp;Old
                                                                                Latitude
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.old_latitude}</div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-fax"></i>&nbsp;&nbsp;Old
                                                                                Longitude
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.old_longitude}</div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-user"></i>&nbsp;&nbsp;Requested
                                                                                Address
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.new_location}>{val?.new_location}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-eraser"></i>&nbsp;&nbsp;Requested
                                                                                Latitude
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.new_latitude}</div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-globe-africa"></i>&nbsp;&nbsp;Requested
                                                                                Longitude
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.new_longitude}</div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-user"></i>&nbsp;&nbsp;Action
                                                                                By

                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.approved_by}</div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-calendar"></i>&nbsp;&nbsp;Action
                                                                                Date

                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.action_date}</div>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    {addressUpdateLogsResponse && addressUpdateLogsResponse?.data !== undefined && addressUpdateLogsResponse?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(addressUpdateLogsResponse?.total / addressUpdateLogsResponse?.per_page)}
                                                forcePage={addressUpdateLogsResponse?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }
                                    {addressUpdateLogsResponse && addressUpdateLogsResponse?.data !== undefined && addressUpdateLogsResponse?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" alt={""}/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/* section ends */}
        </>
    )
}

export default LeadAddressUpdateLogs